import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SealidsReducer(state = initialState.budgettypes, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETTYPES_SUCCESS:
      return action.budgettypes;
    default:
      return state;
  }
}
